export var EsignFormTabs;
(function (EsignFormTabs) {
    EsignFormTabs["Parties"] = "parties";
    EsignFormTabs["Settings"] = "settings";
})(EsignFormTabs || (EsignFormTabs = {}));
